import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  color?: string;
}

const TrendingDown: React.FC<Props> = ({
  size = 18,
  color = '#216CC2',
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMid meet"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    role="img"
    {...rest}
  >
    <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);

export default TrendingDown;
